/**
 * 内置在线客服入口
 */
import { csBus } from '@/utils/csBus'
import { getToken } from '@/utils/auth'

/**
 * @param {import('vue').default} vm 组件实例
 */
export function openCustomerService(vm) {
  if (!vm) return
  const token = getToken()
  if (!token) {
    const msg =
      (vm.$i18n && vm.$t && vm.$t('customerService.loginRequired')) ||
      'Please log in to contact support.'
    if (vm.$message) vm.$message.warning(msg)
    return
  }
  csBus.$emit('open')
}
